
import Vue from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import { STORAGE_OPTION, RD_ADMIN_PERMISSION_LABEL } from '@run-diffusion/shared';
import { UPSELL_TYPE } from '@/constants/constants';
import WorkspaceCard from '@/views/Workspaces/WorkspaceCard.vue';
import BorderSelectCard from '@/components/BorderSelectCard.vue';
import RdBorderCardUpsell from '@/components/RdBorderCardUpsell.vue';
import StorageOptionCard from '@/views/Sessions/StorageOptionsList/StorageOptionCard.vue';
import { RUNNITS_OWNER_SELECTION } from '@/views/Runnits/constants';
import { ROUTER } from '@/router/constants';
import { TeamUserMixin } from '@/mixins';

export default Vue.extend({
	name: 'StorageOptionsList',
	mixins: [
		TeamUserMixin,
	],
	props: {
		runnitsOwnerSelection: { type: String, default: null },
		selectedWorkspaceId: { type: String, default: null },
	},
	data () {
		return {
			ROUTER,
			RD_ADMIN_PERMISSION_LABEL,
			UPSELL_TYPE,
			STORAGE_OPTION,
			RUNNITS_OWNER_SELECTION,
			selectedStorageOption: STORAGE_OPTION.PUBLIC,
		};
	},
	computed: {
		...mapState([
			'user',
			'team',
			'workspaces',
			'runnitState',
		]),
		...mapGetters([
			'userClubOfferBenefits',
			'displayLabels',
		]),
		currRunnitsOwnerSelection () {
			// Prefer prop if provided (for static cases), otherwise use Vuex state
			if (this.runnitsOwnerSelection) {
				return this.runnitsOwnerSelection;
			}
			return (this.runnitState && this.runnitState.runnitsOwnerSelection) || RUNNITS_OWNER_SELECTION.USER;
		},
		items () {
			return [
				...(!this.userClubOfferBenefits.isCc ? [{
					value: STORAGE_OPTION.PUBLIC,
					label: 'Pay As You Go Storage',
					icon: 'mdi-timer-outline',
					descriptionHtml: '<div>(72 hour data retention)</div>',
				}] : []),
				{
					value: STORAGE_OPTION.PRIVATE,
					label: 'Creator\'s Club Personal Storage',
					icon: 'mdi-star-box-outline',
					descriptionHtml: '<div>(100 GB forever)</div>',
				},
			];
		},
	},
	watch: {
		user: {
			immediate: true,
			handler () {
				if (this.userClubOfferBenefits.isCc) {
					this.selectedStorageOption = STORAGE_OPTION.PRIVATE;
				} else {
					this.selectedStorageOption = STORAGE_OPTION.PUBLIC;
				}
			},
		},
	},
	methods: {
		...mapActions([
			'setUpsellDialog',
		]),
		doUpsellToCreatorClub () {
			this.setUpsellDialog({ creatorsClub: true });
		},
		onSelectStorageOption (storageOptionValue: string) {
			if (
				(!this.userClubOfferBenefits.isCc && storageOptionValue === STORAGE_OPTION.PUBLIC) ||
				(this.userClubOfferBenefits.isCc && storageOptionValue === STORAGE_OPTION.PRIVATE)
			) {
				this.selectedStorageOption = storageOptionValue;
				this.$emit('on-select-storage-option', storageOptionValue);
			}
		},
	},
	components: {
		RdBorderCardUpsell,
		BorderSelectCard,
		WorkspaceCard,
		StorageOptionCard,
	},
});
